import { useCallback } from 'react';
import { RefObject } from 'react';
import { PopoverPosition } from '../types';

export function useCalculatePosition({
  triggerRef,
  contentRef,
  currentPosition,
  position,
}: {
  triggerRef: RefObject<HTMLElement>;
  contentRef: RefObject<HTMLElement>;
  currentPosition: PopoverPosition;
  position: PopoverPosition;
}) {
  return useCallback(() => {
    if (typeof window === 'undefined') return currentPosition;
    if (!triggerRef.current || !contentRef.current) return currentPosition;

    const buttonRect = triggerRef.current.getBoundingClientRect();
    const popoverRect = contentRef.current?.getBoundingClientRect();

    // Get viewport dimensions
    const viewportWidth = document.body.offsetWidth;
    const viewportHeight = document.body.offsetHeight;
    const scrollTop = window.pageYOffset;

    // Calculate hypothetical positions to check boundaries
    const positionTop = buttonRect.top - popoverRect.height - 8;
    const positionBottom = buttonRect.bottom + 8 + popoverRect.height;
    const positionLeft = buttonRect.left - popoverRect.width - 8;
    const positionRight = buttonRect.right + 8 + popoverRect.width;

    // Determine optimal position based on screen boundaries
    let bestPosition = position;

    if (bestPosition === 'top' && positionTop < 140 - scrollTop) {
      bestPosition = 'bottom';
    } else if (
      (bestPosition === 'bottom' &&
        positionBottom > scrollTop + viewportHeight) ||
      positionBottom > viewportHeight
    ) {
      bestPosition = 'top';
    }

    if (bestPosition === 'left' && positionLeft < 0) {
      bestPosition = 'right';
    } else if (bestPosition === 'right' && positionRight > viewportWidth) {
      bestPosition = 'left';
    }

    return bestPosition;
  }, [currentPosition, position]);
}
